<nz-modal [nzVisible]='isVisible' [nzFooter]='null' [nzClosable]="false" (nzOnCancel)='handleZoonOut()'
  nzWrapClassName='incentive-insight-modal' [nzWidth]='"100vm"'>
  <ng-container *nzModalContent>
    <div class='ictv-content-body' [ngClass]='isOpen ? "open" : "close"' *ngIf='incentiveDetail'>
      <div class='ictv-content-inner'>
        <i class='app-close-icon' nz-icon nzType='close-circle' nzTheme='outline' nz-popconfirm
          [nzPopconfirmTitle]="'message.sureToHide' | translate" (nzOnConfirm)="handleClose()"
          nzPopconfirmPlacement="top"></i>
        <i (click)='handleZoonOut()' class='app-zoonout-icon' nz-icon nzType='minus-circle' nzTheme='outline'></i>
        <app-incentive-view *ngIf='qrUrl' [incentiveDetail]='incentiveDetail' [qrUrl]='qrUrl'
          [isMobile]='false'></app-incentive-view>
      </div>
    </div>
  </ng-container>
</nz-modal>